import { routes } from '../home/routes';
import { ModuleBase } from '../../shared/modules';

export class HomeModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
